module.exports = __webpack_public_path__ + "img/square.5fbd30bc.svg";